export default __webpack_public_path__ + "static/media/about-gallery-2-comp.7029c27e.png";